import { useParams } from "react-router-dom";
import ContainerTitulo from "../../../components/Formularios/Container/ContainerTitulo";
import FormCodSistema from "./formulario";
// import FormEmpresa from "./components/formulario";

export function CodigiodoSistemaEditar() {
  const idcodigo = useParams();
  return (
    <>
      <div className="container-fluid mt-2">
        <ContainerTitulo titulo="Editar Código do Sistema" />
        <FormCodSistema idcodigo={idcodigo.id} acao="Editar" />
      </div>
    </>
  );
}
